import { Utilities as utilities } from "@truckdown/framework";

export class IPCountryRange {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, "_id", utilities.data.newObjectId());
            this.ipAddressStart = utilities.json.getStringValue(json, "ips", '');
            this.ipAddressEnd = utilities.json.getStringValue(json, "ipe", '');
            this.countryCode = utilities.json.getStringValue(json, "cc", '');
            this.ipValueStart = utilities.json.getArrayValue(json,
                (itm) => { return itm as number; }, "IS", []);
            this.ipValueEnd = utilities.json.getArrayValue(json,
                (itm) => { return itm as number; }, "IE", []);
        }
    }

    toJSON() {
        return {
            _id: this.id,
            ips: this.ipAddressStart,
            ipe: this.ipAddressEnd,
            cc: this.countryCode,
            IS: this.ipValueStart,
            IE: this.ipValueEnd
        };
    }

    id: string = utilities.data.newObjectId();
    ipAddressStart: string = '';
    ipAddressEnd: string = '';
    countryCode: string = '';
    ipValueStart: number[] = [];
    ipValueEnd: number[] = [];
}